import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isCompleteCallback, parseCallbackParams } from "../parseCallbackParams";
import { useAuth } from "../useAuth";

export default function CallbackPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = parseCallbackParams(new URL(window.location.href));
    if (!isCompleteCallback(params)) {
      setError("Paramètres d'authentification incomplets.");
      const timer = setTimeout(() => navigate("/signin", { replace: true }), 1500);
      return () => clearTimeout(timer);
    }
    login({ token: params.token, refreshToken: params.refreshToken, userId: params.userId })
      .then(() => navigate("/admin", { replace: true }))
      .catch(() => {
        setError("Échec de la connexion.");
        setTimeout(() => navigate("/signin", { replace: true }), 1500);
      });
  }, [login, navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "var(--sp-3)",
        background: "var(--paper)",
        color: "var(--ink-mute)",
        fontFamily: "var(--font-body)",
        fontSize: 14,
        position: "relative",
        zIndex: 1,
      }}
    >
      <div
        style={{
          fontFamily: "var(--font-display)",
          fontSize: 22,
          color: "var(--ink)",
          textTransform: "uppercase",
          letterSpacing: "-0.01em",
        }}
      >
        {error ? "Oups" : "Connexion en cours"}
      </div>
      <div>{error ?? "Authentification en cours, merci de patienter…"}</div>
    </div>
  );
}
